export default () => {
  // Vanilla JS for footer sub-menus
  document.addEventListener('DOMContentLoaded', function () {
    // Find all top-level menu titles with a submenu
    const topLevels = document.querySelectorAll('.footer__navigation__toplevel');

    topLevels.forEach(function (topLevel) {
      const arrow = topLevel.querySelector('.material-symbols-outlined');
      const submenu = topLevel.parentElement.querySelector('.footer__navigation__submenu');
      if (arrow && submenu) {
        arrow.addEventListener('click', function (event) {
          event.preventDefault();
          submenu.classList.toggle('open');
        });
      }
    });
  });
};
// Utility function for mobile check (if needed elsewhere)
export function isMobile() {
  return window.innerWidth < 1024;
}